export default {
  MuiStepLabel: {
    styleOverrides: {
      root: {
        alignItems: 'flex-start'
      },
      label: {
        fontSize: '16px',
        fontWeight: 'bold',
        '&.Mui-active': {
          color: '#005DCC',
          fontWeight: 'bold'
        },
        '&.Mui-completed': {
          color: '#B1B2B4',
          fontWeight: 'bold'
        }
      },
      labelContainer: {
        color: '#B1B2B4'
      }
    }
  },
  MuiStepIcon: {
    styleOverrides: {
      root: {
        fontSize: '24px',
        color: '#EAEAEB',
        '&.Mui-active': {
          color: '#005DCC',
          '& text': {
            fill: '#ffffff'
          }
        },
        '&.Mui-completed': {
          color: '#cccccc'
        }
      },
      text: {
        fill: '#96989C'
      }
    }
  }
};
